import styled from '@emotion/styled'
import {theme} from '../../theme'

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[5]} 0;
  min-height: 100%;
  width: 100%;
  flex: 1;
  min-width: 0;
`

export const ContentRow = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
`

export const ContentAreaWrapper = styled.main`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  min-width: 0 !important;
`

// The 1200px cap keeps the form-heavy steps now it can be fixed or floating width.
export const ContentArea = styled.main`
  min-height: fit-content !important;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: ${({fullWidth}) => (fullWidth ? 'none' : '1200px')};
  min-width: 0 !important;
`

export const CatalogContentAreaWrapper = styled.main`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  min-width: 0 !important;
`

// Pure layout — no border/background of its own. That look now lives on
// StepCard (body) and FooterRow (footer) individually, so each renders as
// its own distinct card with a gap between them, instead of one shared frame
// enclosing both.
export const CatalogContentArea = styled.main`
  min-height: fit-content !important;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0 !important;
`

export const OrderSummaryColumn = styled.div`
  flex: 0 0 380px;
  min-width: 320px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: ${theme.space[1.5]};
`

// Outer frame around one step's StepCard + footer together — gives the pair
// one visible boundary (same border as FooterRow) while StepCard and the
// footer keep their own individual background/radius inside it. Each step
// renders <StepCardWrapper><StepCard>...</StepCard><XxxFooter /></StepCardWrapper>.
// Width varies per step: email-lookup (`fitContent`) shrinks to its own
// narrow input row, Account Info (`isAccountInfoComponent`) is 90%, and
// every other step is full width by default. `blurred` (currently only used
// by PaymentDetailsStep while its status drawer is open) disables just this
// card — not the page header/stepper above it, and not the drawer/tab, which
// render as siblings outside this wrapper. It no longer blurs the card's own
// content (filter: blur made the actual text/inputs behind it unreadable);
// PaymentDetailsStep instead layers its own StatusOverlay (a translucent
// white sheet) on top while blurred — position: relative here is what lets
// that overlay position itself against this card.
export const StepCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid #d6def0;
  border-radius: ${theme.radii.xl};
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
  background: linear-gradient(180deg, #f1f2ff 88.65%, #fdfdff 100%);
  width: ${({fitContent, isAccountInfoComponent}) =>
    fitContent ? 'fit-content' : isAccountInfoComponent ? '90%' : '100%'};
  pointer-events: ${({blurred}) => (blurred ? 'none' : 'auto')};
`

// The step body card — every step's actual content (Account Info, Catalog,
// Scheduling, Payment Details) renders inside this. Its own header text
// (PageHeader/PageHeading) sits OUTSIDE this card with no background/border
// of its own; FooterRow is a separate card of the same kind below it, not
// nested inside this one. `noPadding` (PaymentDetailsStep) lets that step's
// own sections (BillToPanel, TwoColumnRow) manage their own padding instead,
// so its Bill To row can sit flush against the card's edges at full width.
export const StepCard = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: ${theme.radii.xl};
  padding: ${({isCatalogStep, isSchedulingStep, noPadding}) =>
    noPadding
      ? '0'
      : isCatalogStep
      ? '4px'
      : isSchedulingStep
      ? '10px'
      : `20px`};
  box-shadow: rgba(0, 0, 0, 0.07) 0px 4px 9.9px 0px;
`

export const StepCardTitle = styled.h2`
  font-size: ${theme.fontSizes['2xl']};
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.space[1]};
`

export const StepCardSubtitle = styled.p`
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.text.secondary};
  margin: 0 0 ${theme.space[6]};
`

// A separate card below StepCard (same gradient/border look, own rounded
// corners), not nested inside it — the two sit as independent siblings with
// a gap between them (margin-top below), matching StepCard's card styling
// without merging into one shared box.
export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 20px;
  // background: linear-gradient(180deg, #f1f2ff 88.65%, #fdfdff 100%);
  // border: 1px solid #d6def0;
  border-radius: 10px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
`

export const FooterCenter = styled.div`
  display: flex;
  gap: ${theme.space[3]};
`

export const PlaceholderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  color: ${theme.colors.text.muted};
  font-size: ${theme.fontSizes.md};
  border: 1px dashed ${theme.colors.border.default};
  border-radius: ${theme.radii.lg};
`
